import React, { Component, useCallback, useEffect, useState } from 'react'
import {
  Row,
  Col,
  Card,
  Tab,
  Tabs,
  Table,
  Button,
  Form,
  Alert,
  FloatingLabel
} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import avatar1 from '../../assets/images/user/avatar-1.jpg'
import avatar2 from '../../assets/images/user/avatar-2.jpg'
import avatar3 from '../../assets/images/user/avatar-3.jpg'
import logoBePass from '../../assets/images/bepass_logo_default.png'

import {
  BsEmojiSunglasses,
  BsSun,
  BsPeople,
  BsPersonBoundingBox,
  BsEmojiWink
} from 'react-icons/bs'
import { VisitorCreate } from '../components/visitorCreate'
import { AccessLog } from '../components/accessLog'
import { FindUser } from '../components/findUser'
import { OpenGate } from '../components/openGate'
import { FindUserFull } from '../components/findUserFull'
import { TotalUsers } from '../components/totalUsers'
import { DailyAccess } from '../components/dailyAccess'
import { GateStatus } from '../components/gateStatus'
import { useForm } from 'react-hook-form'

import { CONFIG } from '../../config/constant'
import { BASE } from '../../basedata/constants'
import { fetchWithApiKey } from '../../config/apiCall'
import { apiCompany } from '../components/ApiCall'
import { signInWithEmailAndPassword } from 'firebase/auth'

import { auth } from '../../config/firebase'

function NotFound() {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
    getValues,
    reset
  } = useForm()

  const authgen = sessionStorage.getItem('auth')
  if (authgen === 'true') {
    window.location.href = '/control'
  }

  const [loginError, setLoginError] = useState({
    status: false,
    message: ''
  })

  const onSubmit = async (data: any) => {


    setLoginError({
      status: false,
      message: ''
    })


    try{

      let isThereAnRole = false
      const userCredential:any = await signInWithEmailAndPassword(auth, data.user, data.password);

      if(userCredential?.user?.accessToken) {
        sessionStorage.setItem('token', userCredential?.user?.accessToken)
        sessionStorage.setItem('user-key', JSON.stringify({user_key: userCredential?.user?.accessToken, tenant_id: 'gremio-ewf1d'}))
        const sessionItem:any = window.sessionStorage.getItem('user-key')
        const {user_key, tenant_id} = sessionItem ? JSON.parse(sessionItem): {user_key:null, tenant_id: null}
        const getRolesAndToken: any = await apiCompany.get(`/firebase/user/roles/${userCredential.user.uid}`,
          {
            headers: {
              'x-api-key': user_key,
              'x-tenant-id': tenant_id,
              'x-api-version': 'v2'
            }
          }
        )

        if(getRolesAndToken?.data?.token) {

          console.log(getRolesAndToken.data)

          for(const item of getRolesAndToken.data.data.loginRoles){
            if(item.companyId === '57e310d5-fcea-42bb-aa80-b8a01a3d8c23'
            ){
              isThereAnRole = true
              sessionStorage.setItem('role', item.role.name)
            }
          }


          if(!isThereAnRole){
            setLoginError({
              status: true,
              message: 'Usuário ou senha inválidos'
            })
            return false
          }

          sessionStorage.setItem('name', userCredential?.user?.displayName || 'Verne')
          sessionStorage.setItem('user-key', JSON.stringify({user_key: getRolesAndToken?.data?.token.apiKey, tenant_id: 'gremio-ewf1d'}))
          sessionStorage.setItem('refreshToken', getRolesAndToken?.data?.refreshToken.token)

          sessionStorage.setItem('auth', 'true')
          sessionStorage.setItem('gate', '1')
          return (window.location.href = '/control')

        }
      }



      setLoginError({
        status: true,
        message: 'Usuário ou senha inválidos'
      })
      return false

    } catch (err: any) {
      setLoginError({
        status: true,
        message: 'Usuário ou senha inválidos'
      })
      return false
    }
  }


  return (

      <div className="auth-wrapper">
        <div className="auth-content">

          <Card className="borderless text-center">
            <Card.Body>
              <div className="mb-4">
                <img src={logoBePass} className='login-logo' />
                <span className='logo-version'>v1.9</span>
              </div>
              </Card.Body>
              </Card>
              </div>
              </div>
  )
}

export default NotFound
